import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import 'antd/dist/antd.css';
import { Tooltip } from '@material-ui/core';
import { Button, Icon, Table, Modal, message, Input, Select} from "antd";
import { Redirect } from 'react-router';
import useAuth from "../../hooks/useAuth";
import Mensajes from "../Mensajes/Mensajes";
import Highlighter from 'react-highlight-words';
import { SearchOutlined, FormOutlined  } from '@ant-design/icons';
const { Option } = Select;

export default function ConsultarRegistros(props) {

    const urlConsultaRegistros = `${localStorage.getItem('SERVERCENTRAL')}/consultaRegistros`;
    const urlDescargaEvidencia = `${localStorage.getItem('SERVERCENTRAL')}/descargaEvidencia`;
    const urlEliminaRegistro = `${localStorage.getItem('SERVERCENTRAL')}/eliminaRegistro`;
    var tiempoMensaje = 5;
    const { user } = useAuth();
    const nivel=localStorage.getItem('DESCRIPCION');

    const dateFormat = "DD-MM-YYYY";

    const [redirect, setRedirect] = useState({
        redirecting: false,
        pathname: "",
        state: {},
    });

    const [visibleAlert, setVisibleAlert] = useState({
        activado: false,
        tipoMensaje: "",
        mensaje: ""
    });

    const [registros, setRegistros] = useState({
        data: [],
        enableCaptura: false,
        enableModificar: false,
        loaded: false,
        distritos: [],
        secciones: []
    });

    const [filtros, setFiltros] = useState({
        distritoSele: null,
        seccionSele: null,
        casillaEspecialSele: null,
        personasConDis: null
    });

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        //position: ["none", "bottomCenter"],
        //onChange: pageOnChange
    });

    const [modalVisible, setModalVisible] = useState({
        visible: false,
        idFormato: -1
    });

    const [busqueda, setbusqueda] = useState({
        searchText: '',
        searchedColumn: ''
    });

    const [entrada, setentrada] = useState({
        searchInput: ''
    });
    
 const  getColumnSearchProps = (dataIndex,title) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div style={{ padding: 8 }}>
            <Input className='buscar'
              ref={node => {
                entrada.searchInput = node;
              }}
              placeholder={`Buscar ${title}`}
              value={selectedKeys[0]}
              onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
              
            />
            <div>
              <Button
                type="primary"
                onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                className="buscarbtn"
              >
                Buscar
              </Button>
              <Button onClick={() => handleReset(clearFilters)} size="small" 
              className="reiniciarbtn"
              >
                Reiniciar
              </Button>
            </div>
          </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#e149a4' : '#e149a4'}} />,
        onFilter: (value, record) =>
          record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
          if (visible) {
            setTimeout(() => entrada.searchInput.select());
          }
        },
        render: text =>
          busqueda.searchedColumn === dataIndex ? (
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[busqueda.searchText]}
              autoEscape
              textToHighlight={text.toString()}
            />
          ) : (
            text
          ),
      });
   
      const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setbusqueda({
          searchText: selectedKeys[0],
          searchedColumn: dataIndex,
        });
      };
    
      const handleReset = clearFilters => {
        clearFilters();
        setbusqueda({ searchText: '' });
      };
    
      //console.log(registros.loaded,"loaded")
    useEffect(() => {
        //console.log(registros.loaded,"loaded1")
        if (!registros.loaded)
            doRequestConsulta();
    }, [registros]);

    const handleNuevoRegistro = (e) => {
        setRedirect(
            {
                redirecting: true,
                pathname: '/registro/registrarFormatos',
                /*pathname: '/registro/consultarRegistro',*/
                state: {}
            }
        );
    };

    const handleClickModificar = useCallback((idFormato, casillaEspecial, distrito,
        idGeografico, observaciones, participacion, seccion, secretario,escrutador)  => {
        //console.log("handleClickConsultar", idVerificacion);
        setRedirect(
            {
                redirecting: true,
                pathname: '/registro/modificarRegistro',
                state: {
                    idFormato: idFormato,
                    casillaEspecial: casillaEspecial,
                    distrito: distrito,
                    idGeografico: idGeografico,
                    observaciones: observaciones,
                    participacion: participacion,
                    seccion: seccion,
                    secretario: secretario,
                    escrutador: escrutador,
                    accion:2 //1 indica consulta, 2 modificación
                }
            }
        );
    });

    const handleClickEliminar = useCallback(idFormato => {
        //console.log("handleClickEliminar", idFormato);
        setModalVisible({
            visible: true,
            idFormato: idFormato
        });
        //doRequestEliminaVerificacion(idVerificacion);
    });

    const handleClickConsultar = useCallback((idFormato, casillaEspecial, distrito,
        idGeografico, observaciones, participacion, seccion, secretario,escrutador)  => {
        //console.log("handleClickConsultar", idVerificacion);
        setRedirect(
            {
                redirecting: true,
                pathname: '/registro/consultarRegistro',
                state: {
                    idFormato: idFormato,
                    casillaEspecial: casillaEspecial,
                    distrito: distrito,
                    idGeografico: idGeografico,
                    observaciones: observaciones,
                    participacion: participacion,
                    seccion: seccion,
                    secretario: secretario,
                    escrutador: escrutador,
                    accion:1 //1 indica consulta, 2 modificación
                }
            }
        );
    });
    

    function doRequestConsulta() {
        if ((user.infoMenu.estadoSelec === null && user.infoMenu.detalleSelec.idEstado === 0) || (user.infoMenu.estadoSelec !== null && user.infoMenu.estadoSelec.idEstado === 0)) {
            /* setVisibleAlert({
                activado: true,
                tipoMensaje: "warning",
                mensaje: "Favor de seleccionar una entidad en el menú del proceso electoral",
            })
            return; */
            message.warning("Favor de seleccionar una entidad en el menú del proceso electoral.",tiempoMensaje);
            return;
        }
        let data = JSON.stringify({
            idEstado: user.infoMenu.estadoSelec !== null ? user.infoMenu.estadoSelec.idEstado : user.infoMenu.detalleSelec.idEstado,
            idProceso: user.infoMenu.detalleSelec.idProcesoElectoral,
            idDetalleProceso: user.infoMenu.detalleSelec.idDetalleProceso,
            ambito: localStorage.getItem('AMBITO'),
            idDistrito: filtros.distritoSele,
            idSeccion: filtros.seccionSele,
            participacion: filtros.personasConDis,
            casillaEspecial: filtros.casillaEspecialSele,
            dtoPaginacion: pagination
        })
        axios
            .post(
                urlConsultaRegistros, data, {
                headers: {
                    'Authorization': localStorage.getItem('accessToken'),
                    'Content-Type': 'application/json',
                    Accept: "application/json",
                }
            }
            ).then(
                response => {
                    if (response.data.entity.code !== 200 && response.data.entity.code !== 403) {
                       /*  setVisibleAlert(
                            {
                                activado: true,
                                tipoMensaje: "error",
                                mensaje: response.data.entity.causa
                            }); */
                            message.error("10.- Ocurrió un error. Comunícate al CAU",tiempoMensaje);
                    }
                    else if (response.data.entity.code === 200) {
                        if (response.data.entity.message !== null && response.data.entity.message !== "") {
                           /*  setVisibleAlert(
                                {
                                    activado: true,
                                    tipoMensaje: "warning",
                                    mensaje: response.data.entity.message
                                }); */
                                message.warning(response.data.entity.message,tiempoMensaje);
                        }
                        else {
                            //console.log("RESUMEN", response.data.entity.resumen)
                            //console.log("pagination request:=>", pagination);
                            setPagination({
                                ...pagination,
                                total: response.data.entity.dtoPaginacion.total
                            });
                          
                            setRegistros({
                                loaded: true,
                                data: response.data.entity.resumen,
                                distritos: Object.entries(response.data.entity.mapaDistritos),
                                secciones: Object.entries(response.data.entity.mapaSecciones),
                                enableCaptura: response.data.entity.enableCaptura,
                                enableModificar: response.data.entity.enableModificar,
                            });
                        }
                    }
                    else {
                        localStorage.clear();
                        // console.log("Borro el local storage");
                        window.location = "/login"
                    }
                }
            ).catch(err => {
                //console.log("Error:=>: doRequestOptions", err)
                if (err.response.status === 403) {
                    localStorage.clear();
                    window.location = "/login"
                    return;
                }
                /* setVisibleAlert(
                    {
                        activado: true,
                        tipoMensaje: "error",
                        mensaje: "Ha ocurrido un error al realizar la petición solicitada"
                    }); */
                    message.error("Ha ocurrido un error al realizar la petición solicitada.", tiempoMensaje);
            });
        setModalVisible({
            visible: false,
            idFormato: -1
        });
    }


    function doRequestEliminaRegistro(idFormato) {
        setVisibleAlert(
            {
                activado: false,
                tipoMensaje: "",
                mensaje: ""
            });
        let data = JSON.stringify({
            idEntidad: user.infoMenu.estadoSelec !== null ? user.infoMenu.estadoSelec.idEstado : user.infoMenu.detalleSelec.idEstado,
            idProceso: user.infoMenu.detalleSelec.idProcesoElectoral,
            idDetalleProceso: user.infoMenu.detalleSelec.idDetalleProceso,
            anioProceso: user.infoMenu.detalleSelec.anio,
            tipoProceso: user.infoMenu.detalleSelec.tipoProceso,
            idFormato: idFormato
        })
        axios
            .post(
                urlEliminaRegistro, data, {
                headers: {
                    'Authorization': localStorage.getItem('accessToken'),
                    'Content-Type': 'application/json',
                    Accept: "application/json",
                }
            }
            ).then(
                response => {
                    if (response.data.entity.code !== 200 && response.data.entity.code !== 403) {
                        /* setVisibleAlert(
                            {
                                activado: true,
                                tipoMensaje: "error",
                                mensaje: response.data.entity.causa
                            }); */
                            message.error("10.- Ocurrió un error. Comunícate al CAU",tiempoMensaje);
                    }
                    else if (response.data.entity.code === 200) {
                        if (response.data.entity.message !== null && response.data.entity.message !== "") {
                            /* setVisibleAlert(
                                {
                                    activado: true,
                                    tipoMensaje: "warning",
                                    mensaje: response.data.entity.message
                                }); */
                                message.warning(response.data.entity.message,tiempoMensaje);
                        }
                        else { 
                           
                            /* setVisibleAlert(
                                {
                                    activado: true,
                                    tipoMensaje: "success",
                                    mensaje: "Se ha eliminado la verificación correctamente."
                                }); */
                                message.success("Se ha eliminado el registro correctamente.",tiempoMensaje);
                              window.location = "/formatoDiscapacidad/formatoDiscapacidad"   
                            setRegistros({
                                loaded: false,
                                data: [],
                                distritos: [],
                                enableCaptura: false,
                                enableModificar: false,
                            });
                           
                        }
                    }
                    else {
                        localStorage.clear();
                        // console.log("Borro el local storage");
                        window.location = "/login"
                    }
                }
            ).catch(err => {
                //console.log("Error:=>: doRequestOptions", err)
                if (err.response.status === 403) {
                    localStorage.clear();
                    window.location = "/login"
                    return;
                }
                /* setVisibleAlert(
                    {
                        activado: true,
                        tipoMensaje: "error",
                        mensaje: "Ha ocurrido un error al realizar la petición solicitada"
                    }); */
                    message.error("Ha ocurrido un error al realizar la petición solicitada.",tiempoMensaje);
            });
            //console.log("rEGISTRO LOAD", registros.loaded)
    }
    //console.log("rEGISTRO LOAD1", registros.loaded)

    const handleClose = () => {
        setVisibleAlert({
            activado: false,
            tipoMensaje: "",
            mensaje: ""
        });
    }

    const handleModalEnviar = () => {
        doRequestEliminaRegistro(modalVisible.idFormato);
    }

    const handleModalCancel = () => {
        setModalVisible({
            visible: false,
            idFormato: -1
        });
    }

    const renderRedirect = () => {
        if (redirect.redirecting) {
            return <Redirect to={{
                pathname: redirect.pathname,
                state: redirect.state
            }
            } />
        }
    }

    const columns = [
        
        {
            title: "No.",
            dataIndex: "consecutivo",
        }, 
        {
            //title: "Distrito",
            title: () => (               
                <div style={{ display: 'flex', width: '100%' }}>
                    <span className="roboto-regular-16-blanco-33" style={{ width: '100%' }}>
                        Distrito
                        <br/>
                        <Select
                            placeholder="TODOS"
                            style={{ width: 200 }}                            
                            loading={!registros.loaded}
                            disabled={!registros.loaded}
                            value={filtros.distritoSele}
                            defaultValue="TODOS"
                            onChange={(option) => {
                                setPagination({
                                    ...pagination,
                                    current: 1,
                                    total: 0,
                                });
                                setFiltros({
                                    ...filtros,
                                    distritoSele: option,
                                    seccionSele: null
                                });
                                setRegistros({
                                    ...registros,
                                    loaded: false
                                });
                            }}
                        >
                            <Option value={null} className="selected-option">TODOS</Option>
                            {registros.distritos.map((item) => {
                                return <Option value={item[0]} className="selected-option">{item[1]}</Option>
                            })}
                        </Select>
                    </span>
                </div>
            ),
            dataIndex: "nombreDistrito",
            filtered: true,            
            //...getColumnSearchProps('nombreDistrito',' Distrito')
        },
        {
            //title: "Sección",
            title: () => (               
                <div style={{ display: 'flex', width: '100%' }}>
                    <span className="roboto-regular-16-blanco-33" style={{ width: '100%' }}>
                        Sección
                        <br/>
                        <Select
                            placeholder="TODAS"
                            style={{ width: 100 }}
                            value={filtros.seccionSele}
                            defaultValue="TODAS"
                            loading={!registros.loaded}
                            disabled={!registros.loaded}
                            onChange={(option) => {
                                setPagination({
                                    ...pagination,
                                    current: 1,
                                    total: 0,
                                });
                                setFiltros({
                                    ...filtros,
                                    seccionSele: option
                                });
                                setRegistros({
                                    ...registros,
                                    loaded: false
                                });
                            }}
                        >
                            <Option value={null} className="selected-option">TODAS</Option>
                                {registros.secciones.map((item) => {
                                    return <Option value={item[0]} className="selected-option">{item[1]}</Option>
                                })}
                        </Select>
                    </span>
                </div>
            ),
            dataIndex: "seccion",
            filter: true,
            //...getColumnSearchProps('seccion', ' Seccion')
        },
        {
            //title: "Casilla Especial",
            title: () => (               
                <div style={{ display: 'flex', width: '100%' }}>
                    <span className="roboto-regular-16-blanco-33" style={{ width: '100%' }}>
                        Casilla Especial
                        <br/>
                        <Select
                            placeholder="TODAS"
                            style={{ width: 100 }}
                            value={filtros.casillaEspecialSele}
                            defaultValue="TODAS"
                            loading={!registros.loaded}
                            disabled={!registros.loaded}
                            onChange={(option) => {
                                setPagination({
                                    ...pagination,
                                    current: 1,
                                    total: 0,
                                });
                                setFiltros({
                                    ...filtros,
                                    casillaEspecialSele: option
                                });
                                setRegistros({
                                    ...registros,
                                    loaded: false
                                });
                            }}
                        >
                            <Option value={null} className="selected-option">TODAS</Option>
                            <Option value="1" className="selected-option">Sí</Option>
                            <Option value="0" className="selected-option">No</Option>
                        </Select>
                    </span>
                </div>
            ),
            dataIndex: "casillaEspecial",
            filter: true,
            //...getColumnSearchProps('casillaEspecial', ' Casilla especial')
        },
        {
            //title: "¿Se presentaron a votar personas con discapacidad?",
            title: () => (               
                <div style={{ display: 'flex', width: '100%' }}>
                    <span className="roboto-regular-16-blanco-33" style={{ width: '100%' }}>
                        ¿Se presentaron a votar personas con discapacidad?
                        <br/>
                        <Select
                            placeholder="TODAS"
                            style={{ width: 100 }}
                            value={filtros.personasConDis}
                            defaultValue="TODAS"
                            loading={!registros.loaded}
                            disabled={!registros.loaded}
                            onChange={(option) => {
                                setPagination({
                                    ...pagination,
                                    current: 1,
                                    total: 0,
                                });
                                setFiltros({
                                    ...filtros,
                                    personasConDis: option
                                });
                                setRegistros({
                                    ...registros,
                                    loaded: false
                                });
                            }}
                        >
                            <Option value={null} className="selected-option">TODAS</Option>
                            <Option value="1" className="selected-option">Sí</Option>
                            <Option value="0" className="selected-option">No</Option>
                        </Select>
                    </span>
                </div>
            ),
            dataIndex: "participacion",

            filter: true,
            //...getColumnSearchProps('participacion', ' Acudieron')
        },
        
        {
            title: "Personas con discapacidad",
            dataIndex: "cantidad",
        },
        {
            title: "Observaciones",
            dataIndex: "observaciones",
        },
        {
            title: "Acciones",
            width: "170px",
            align: "center",
            dataIndex: "operation",
            render: (text, record) => {
                //console.log("Record v", record);
                return (
                    
                    <div className="contenedor-acciones">
                    <Tooltip title="Consultar">
                        <Button
                            className="ilist"
                            type="link"
                            shape="circle"
                            onClick={handleClickConsultar.bind(
                                this,
                                record.idFormato,
                                record.casillaEspecial,
                                record.distrito,
                                record.idGeografico,
                                record.observaciones,
                                record.participacion,
                                record.seccion,
                                record.secretario,
                                record.escrutador
                                )} 
                        >
                            <Icon type="eye" />
                        </Button>
                        </Tooltip>
                        <Tooltip title="Modificar">
                        <Button
                            className="ilist"
                            type="link"
                            shape="circle"
                            disabled={!registros.enableModificar}
                            onClick={handleClickModificar.bind(
                                this,
                                record.idFormato,
                                record.casillaEspecial,
                                record.distrito,
                                record.idGeografico,
                                record.observaciones,
                                record.participacion,
                                record.seccion,
                                record.secretario,
                                record.escrutador
                    )}
                        >
                           <FormOutlined />
                        </Button>
                            </Tooltip>
                         <Tooltip title="Eliminar">
                        <Button
                            className="ilist"
                            type="link"
                            shape="circle"
                            disabled={!registros.enableModificar}
                            onClick={handleClickEliminar.bind(
                                this,
                                record.idFormato)}
                        >
                            <Icon type="delete" />
                        </Button>
                        </Tooltip>
                    </div>
                )
            }
        }
    ];
    return (
        <div>
            {renderRedirect()}
            {visibleAlert.activado ?
                (
                    <div>
                        <Mensajes tipoMensaje={visibleAlert.tipoMensaje} mensaje={visibleAlert.mensaje} handleClose={handleClose} />
                        <br />
                    </div>
                ) : null
            }
            <Modal
                visible={modalVisible.visible}
                title='¿Está seguro de eliminar el registro?'
                closable={false}
                footer={[
                    <div className="confirmacion-footer">
                        <Button onClick={handleModalCancel} className="boton-modal-cancelar"
                        >
                            Cancelar
                        </Button>
                        <Button type="primary"
                            onClick={handleModalEnviar}
                            className="boton-modal-aceptar"
                            disabled={!registros.enableModificar}
                        >
                            Aceptar
                        </Button>
                    </div>
                ]}
            />
            <h1 className="titulo-verificacion">Registro de personas con discapacidad que acuden a votar</h1>
            <br />
            <br />
            <Button
                onClick={handleNuevoRegistro}
                disabled={!registros.enableCaptura}
                className="boton-agregar-verificacion"
            >
                <div>
                    <div>
                        <Icon type="plus" className="icono-plus-verificacion"/> <Icon type="form" className="icono-form-verificacion"/>
                    </div>
                    Nuevo Registro
                </div>
            </Button>
            <br />
            <br />
            <br />
            {nivel !== "TODOS-OC"?
            <><h2 className="titulo-listado-verificacion">Lista de registros</h2>
            <Table
                className="tabla-verificaciones"
                pagination={pagination}
                bordered
                dataSource={registros.data}
                columns={columns}
                loading={!registros.loaded}
                onChange={ (pagination, filters, sorter) => {
                    //console.log("pagination event:=>", pagination);
                    setPagination(pagination);
                    setRegistros({...registros, loaded: false});
                }}
            /></>:""}
        </div>
    )

}